const UPDATE_ACCOUNT_DATA = 'UPDATE_ACCOUNT_DATA';
const UPDATE_EMAIL_AVAILABLE = 'UPDATE_EMAIL_AVAILABLE';
const UPDATE_SIGNUP_STATE = 'UPDATE_SIGNUP_STATE';
const UPDATE_AUTH_KEY = 'UPDATE_AUTH_KEY';
const KILL_AUTH_KEY = 'KILL_AUTH_KEY,';
const UPDATE_INDEX_REPORT = 'UPDATE_INDEX_REPORT';
const KILL_INDEX_REPORT = 'KILL_INDEX_REPORT';
const FILTER_UPDATE = 'FILTER_UPDATE';
const AUTH_RECORD = 'AUTH_RECORD';
const USER_RECORD = 'USER_RECORD';
const ADM_INDEX_RECORD = 'ADM_INDEX_RECORD';
const ADM_EVALS_RECORD = 'ADM_EVALS_RECORD';

export {
  UPDATE_ACCOUNT_DATA,
  UPDATE_EMAIL_AVAILABLE,
  UPDATE_AUTH_KEY,
  KILL_AUTH_KEY,
  UPDATE_INDEX_REPORT,
  KILL_INDEX_REPORT,
  FILTER_UPDATE,
  UPDATE_SIGNUP_STATE,
  AUTH_RECORD,
  USER_RECORD,
  ADM_EVALS_RECORD,
  ADM_INDEX_RECORD,
};
